export default function HighscoreUpdater(view) {
  async function update(result = null) {
    console.log("Fetching highscore...");
    let response = null;
    if (result) {
      console.log("Posting highscore...", result);
      response = await fetch("/highscore", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(result)
      });
    } else {
      response = await fetch("/highscore");
    }
    const data = await response.json();
    if (data.success) {
      const {
        highscore,
        newHighscore
      } = data.payload;
      view.update(Object.entries(highscore), newHighscore);
    }
  }
  return {
    update
  };
}